import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { APP_SETTINGS_LISTINGS_SHOW_SIGNED_PROGRAMS_KEY, APP_SETTINGS_QUERY_KEY } from '@/config/appSettingsKeys'

/**
 * Global feature flag: show signed programmes in TV listings (BSL from accessibility uploads and "Signed:" title).
 * When false, signed/BSL detection is not run and the BSL filter is hidden on the Listings screen.
 * Stored in app_settings; toggled in Admin → Feature flags.
 */
export function useListingsShowSignedProgramsFlag() {
  const { data: value, isLoading } = useQuery({
    queryKey: [...APP_SETTINGS_QUERY_KEY, APP_SETTINGS_LISTINGS_SHOW_SIGNED_PROGRAMS_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('app_settings')
        .select('value')
        .eq('key', APP_SETTINGS_LISTINGS_SHOW_SIGNED_PROGRAMS_KEY)
        .maybeSingle()
      if (error) return true // default on for backward compatibility
      return data?.value !== 'false'
    },
    staleTime: 60_000,
  })
  return { showSignedInListings: value ?? true, isLoading }
}
